import { Component, OnInit,TemplateRef } from '@angular/core';
import { ReportsService } from '../../core/services/reports/reports.service';
import { Observable, forkJoin } from 'rxjs';
import * as $ from 'jquery';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Chart,ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { MultiDataSet, Label, SingleDataSet, Color } from 'ng2-charts';
import * as DataLabelPlugin from 'chartjs-plugin-datalabels';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  providers:[ReportsService, NgxSpinnerService]
})
export class ReportsComponent implements OnInit {
  modalRef: BsModalRef;   
  accordionView : boolean = false;
  collegeName : string = ''; 
  region:string='Anoka-Hennepin';
  program:string='AVID';
  colleges : any = [];  
  regions:any=[];
  programs:any=[];
  sentReportForm: FormGroup; 
  //============================================Common Section====================================
  
  barChartOptions: ChartOptions = {responsive: true, scales: {xAxes: [{ display: true, gridLines: {drawOnChartArea:false}}],yAxes: [{display: true, gridLines: {drawOnChartArea:false},ticks: {display: true, beginAtZero:true, maxTicksLimit:5, callback: function(label) { return  label; }}}]},plugins :{datalabels : {color : '#000000', align : 'top' }}};  
  barChartType: ChartType = 'bar';
  barChartLegend = false;

  virticalBarCharOptions: ChartOptions = {responsive: true, scales: {xAxes: [{ display: true, gridLines: {drawOnChartArea:false},ticks: {autoSkip: true, maxRotation: 90, minRotation: 90}}], yAxes: [{display: true, gridLines: {drawOnChartArea:false},ticks: {display: true, beginAtZero:true, maxTicksLimit:5,callback: function(label, index, labels) {return  label;}}}]}, plugins :{datalabels : {color : '#000000', align : 'top' }}};

  pieChartType: ChartType = 'pie';
  pieChartLegend = true;
  pieChartColors: Color[] = [{backgroundColor: ['#202945','#00a6b6','#2c9a42', '#76b6bc']}];
  pieChartOptions: ChartOptions = {responsive: true, legend: {display: true, position: 'right', labels: {fontColor: '#000000'}}, plugins :{datalabels : {color : '#ffffff', formatter: function (value, ctx) {let sum = 0;let dataArr = ctx.chart.data.datasets[0].data;dataArr.forEach(data => {sum += data;});return (value * 100 / sum).toFixed(0) + "%";}}}};
  
  lineChartLegend = true;
  lineChartPlugins = [DataLabelPlugin];
  lineChartType = 'line';
  lineChartOptions = {responsive: true,legend: {display: true, position: 'bottom', labels: {fontColor: '#000'}},scales: {xAxes: [{ display: true, gridLines: {drawOnChartArea:false}}],yAxes: [{display: true, gridLines: {drawOnChartArea:false},ticks: {display: true,beginAtZero:true, callback: function(label, index, labels) {return  label; }}}]},plugins :{datalabels : {color : '#000000', align : 'top' }}};

  doughnutChartType: ChartType = 'doughnut';
  doughnutChartOptions: ChartOptions = {legend:{position: 'top',align:'start'}, plugins :{datalabels : {color : '#fff', formatter: function (value, ctx) {let sum = 0; let dataArr = ctx.chart.data.datasets[0].data; dataArr.forEach(data => {sum += data; }); return (value * 100 / sum).toFixed(0) + "%";}}}};
  doughnutChartPlugins = [DataLabelPlugin]
  doughnutChartColors: Color[] = [{backgroundColor: ['#202945','#00a6b6','#2c9a42', '#76b6bc']}];

  //========================================== Home Tab =========================================
  displayreports : boolean = false;
  applicationCounts : any;
  reportsData : any = {};
  group:any={};
  groupIdx:any={};  
  doughnutChartLabels: Label[] = [];
  doughnutChartData: MultiDataSet = [];

  //============================================Detail Tab========================================
  showDetailsCharts:boolean = false;
  detailsApplicationCounts : any;

  detailsBarChartLabels: Label[] = [];
  detailsBarChartData: ChartDataSets[] = [];

  detailsBarSchoolChartLabels: Label[] = [];
  detailsBarSchoolChartData: ChartDataSets[] = [];

  detailsPieChartLabels: Label[] = [];
  detailsPieChartData: SingleDataSet = [];

  detailsLineChartData: ChartDataSets[] = [];
  detailsLineChartLabels: Label[] = [];

  //============================================Segmentation tab=======================================
  showSegmentationCharts : boolean = false;
  totalSegmentationCount : number = 0;
  segmentationBarSchoolChartLabels: Label[] = [];
  segmentationBarSchoolChartData: ChartDataSets[] = [];
  segmentationBarChartLabels: Label[] = [];
  segmentationBarChartData: ChartDataSets[] = []; 
  segmentationPieChartLabels: Label[] = [];
  segmentationPieChartData: SingleDataSet = [];

  //============================================Program tab=======================================
  showProgramCharts : boolean = false;
  totalProgramCount : number = 0;
  programBarSchoolChartLabels: Label[] = [];
  programBarSchoolChartData: ChartDataSets[] = [];
  programBarChartLabels: Label[] = [];
  programBarChartData: ChartDataSets[] = []; 
  programPieChartLabels: Label[] = [];
  programPieChartData: SingleDataSet = [];
  constructor(private modalService: BsModalService, private reportService: ReportsService, private spinnerService: NgxSpinnerService,  private formBuilder: FormBuilder ) { }

  ngOnInit() {
    
    $('.head-top').children('div.container').css('max-width','1340px');
    $('.full').css('max-width','1340px');
    $('.page-logo').css('max-width','1340px');

    this.reportService.getCollege().subscribe(res => {
      this.colleges = res.data;
    });

    this.reportService.getRegions().subscribe(res => {
      this.regions = res.data;
    });

    this.reportService.getPrograms().subscribe(res => {
      this.programs = res.data;
    });
    this.sentReportForm = this.formBuilder.group({
      subject: ['',[Validators.required]],
      inputEmail3: ['', [Validators.required, Validators.email]],
      exampleFormControlTextarea1:[''],     
     
    });
    this.getCollegeReport("");
    this.getDetailsPageChartData("");
    this.getPrograms(this.program);
    this.getRegions(this.region);
    
    $('.bannerTitle').html('COUNSELOR REPORT 2021-22');
    $('.links-m').html('');
    $('.count').each(function () {
      $(this).prop('Counter',0).animate({
        Counter: $(this).text()
      }, {
        duration: 500,
        easing: 'swing',
        step: function (now) {
          $(this).text(Math.ceil(now));
        }
      });
    });
  }

  getCollegeReport(colName : string) {
    this.spinnerService.show();
    this.displayreports = false;
    let getTotalApplicationsCount = this.reportService.getTotalApplicationsCount(colName);
    let getReportData = this.reportService.get(colName);

    forkJoin([getReportData, getTotalApplicationsCount]).subscribe(res => {
        this.applicationCounts = res[1].data;
        this.reportsData = res[0].data;
        this.displayreports = true;
        this.doughnutChartLabels = [];
        this.doughnutChartData = [];
        let countArr = [];
        let count = 0;
        this.spinnerService.hide();
        if (this.applicationCounts.submission_pending > 0) {
          countArr.push(this.applicationCounts.submission_pending);
          this.doughnutChartLabels.push('Submission Pending');
          this.group['submission_pending'] = false;
          this.groupIdx[count++] = 'submission_pending';
        }
        if (this.applicationCounts.transcripts_pending > 0) {
          countArr.push(this.applicationCounts.transcripts_pending);
          this.doughnutChartLabels.push('Transcripts Required');
          this.group['transcripts_pending'] = false;
          this.groupIdx[count++] = 'transcripts_pending';
        }
        if (this.applicationCounts.recommendation_pending > 0) {
          countArr.push(this.applicationCounts.recommendation_pending);
          this.doughnutChartLabels.push('Recommendations Pending');
          this.group['recommendation_pending'] = false;
          this.groupIdx[count++] = 'recommendation_pending';
        }
        if (this.applicationCounts.multiple_pending > 0) {
          countArr.push(this.applicationCounts.multiple_pending);
          this.doughnutChartLabels.push('Multiple Steps Pending');
          this.group['multiple_pending'] = false;
          this.groupIdx[count++] = 'multiple_pending';
        }
        this.doughnutChartData.push(countArr);
    });
  }

  getDetailsPageChartData(institude: string){
    this.detailsPieChartLabels = [];
    this.detailsPieChartData = [];
    this.detailsBarChartLabels = [];
    this.detailsBarChartData = [];
    this.detailsBarSchoolChartLabels = [];
    this.detailsBarSchoolChartData = [];
    this.detailsLineChartData = [];
    this.detailsLineChartLabels = [];
    if (institude === undefined) {
      institude = "";
      this.collegeName = "";
    }

    let getStudentsCountByGender = this.reportService.getStudentsCountByGender(institude);
    let getStudentsCountByEthnicity = this.reportService.getStudentsCountByEthnicity(institude);
    let getCompletedApplicationsBySchool = this.reportService.getCompletedApplicationsBySchool(institude);
    let getTotalApplicationsCount = this.reportService.getTotalApplicationsCount(institude);
    let getApplicationsCountByMonth = this.reportService.getApplicationsCountByMonth(institude);
    
    this.showDetailsCharts = false;

    forkJoin([getStudentsCountByGender, getStudentsCountByEthnicity,
       getCompletedApplicationsBySchool, getApplicationsCountByMonth, 
       getTotalApplicationsCount]).subscribe(results => {
      this.detailsApplicationCounts = results[4].data;
      this.showDetailsCharts = true;
      //Pie chart Gender
      for (let i=0;i<results[0].data.length;i++) {
          this.detailsPieChartLabels.push(results[0].data[i]._id);
          this.detailsPieChartData.push(results[0].data[i].count);
      }
      //Line chart
      let line = results[3].data;
      let i = 0;
      Object.keys(line).forEach(year => {
        let yearobj = line[year];
        let color = '#2c9a42';
        if (i == 0) {
          this.detailsLineChartLabels = yearobj.months;
          color = '#76b6bc';
        }
        i++;
        this.detailsLineChartData.push({data: yearobj.values, fill: false, label : year,
           borderColor:color,pointBorderColor: color,
           pointBackgroundColor: color,
           pointHoverBackgroundColor: color,
           pointHoverBorderColor: color});
      });
     
      //Bar chart Ethnicity
      let barData = [];
      let barCharArr = [];
      let barLableArr = results[1].data.sort(this.compare);
      for (let i=0;i<barLableArr.length;i++) {
        if (barLableArr[i]._id.length > 0) {
          this.detailsBarChartLabels.push(barLableArr[i]._id.split(" "));
          barData.push(barLableArr[i].count);
        }
      }
      barCharArr.push({data: barData, backgroundColor: '#76b6bc', hoverBackgroundColor: '#76b6bc'});
      this.detailsBarChartData = barCharArr;
      // Bar chart for school
      barData = [];
      barCharArr = [];
      barLableArr = results[2].data.sort(this.compare);
      for (let i=0;i<results[2].data.length;i++) {
          this.detailsBarSchoolChartLabels.push(barLableArr[i]._id.replace('High School', ''));
          barData.push(barLableArr[i].count);
      }
      barCharArr.push({data: barData, backgroundColor: '#76b6bc', hoverBackgroundColor: '#76b6bc'});
      this.detailsBarSchoolChartData = barCharArr;
    });
  }  

  getPrograms(program:string) {
    this.programPieChartLabels = [];
    this.programPieChartData = [];
    this.programBarChartLabels = [];
    this.programBarChartData = [];
    this.programBarSchoolChartLabels = [];
    this.programBarSchoolChartData = [];
    this.totalProgramCount = 0;
    if (program === undefined) {
      program = null;
    }
    this.showProgramCharts = false;
    let getCompletedApplicationsBySchoolPerProgram = this.reportService.getCompletedApplicationsBySchoolPerProgram(program);
    let getStudentsCountByGenderPerProgram = this.reportService.getStudentsCountByGenderPerProgram(program);
    let getStudentsCountByEthnicityPerProgram = this.reportService.getStudentsCountByEthnicityPerProgram(program);
    forkJoin([getStudentsCountByEthnicityPerProgram, getStudentsCountByGenderPerProgram, getCompletedApplicationsBySchoolPerProgram]).subscribe(res => {
     
      //Bar chart Ethnicity
      let barData = [];
      let barCharArr = [];
      let barLableArr = res[0].data.sort(this.compare);
      for (let i=0;i<barLableArr.length;i++) {
        if (barLableArr[i]._id.length > 0) {
          this.programBarChartLabels.push(barLableArr[i]._id.split(" "));
          barData.push(barLableArr[i].count);
          this.totalProgramCount += barLableArr[i].count;
        }
      }
      barCharArr.push({data: barData, backgroundColor: '#76b6bc', hoverBackgroundColor: '#76b6bc'});
      this.programBarChartData = barCharArr;

      for (let i=0;i<res[1].data.length;i++) {
        this.programPieChartLabels.push(res[1].data[i]._id);
        this.programPieChartData.push(res[1].data[i].count);
      }
      // Bar chart for school
      barData = [];
      barCharArr = [];
      barLableArr = res[2].data.sort(this.compare);
      for (let i=0;i<barLableArr.length;i++) {
          this.programBarSchoolChartLabels.push(barLableArr[i].name.replace('High School', ''));
          barData.push(barLableArr[i].count);
      }
      barCharArr.push({data: barData, backgroundColor: '#76b6bc', hoverBackgroundColor: '#76b6bc'});
      this.programBarSchoolChartData = barCharArr;
      this.showProgramCharts = true;
    });
  }

  getRegions(region:string) {
    this.segmentationBarChartData = [];
    this.segmentationBarChartLabels = [];
    this.segmentationBarSchoolChartData = [];
    this.segmentationBarSchoolChartLabels = [];
    this.segmentationPieChartData = [];
    this.segmentationPieChartLabels = [];
    this.totalSegmentationCount = 0;
    if (region === undefined) {
      region = null;
    }
    this.showSegmentationCharts = false;
    let getCompletedApplicationsBySchoolPerRegion = this.reportService.getCompletedApplicationsBySchoolPerRegion(region);
    let getStudentsCountByGenderPerRegion = this.reportService.getStudentsCountByGenderPerRegion(region);
    let getStudentsCountByEthnicityPerRegion = this.reportService.getStudentsCountByEthnicityPerRegion(region);
    forkJoin([getStudentsCountByEthnicityPerRegion, getStudentsCountByGenderPerRegion, getCompletedApplicationsBySchoolPerRegion]).subscribe(res => {
     
      //Bar chart Ethnicity
      let barData = [];
      let barCharArr = [];
      let barLableArr = res[0].data.sort(this.compare);
      for (let i=0;i<barLableArr.length;i++) {
        if (barLableArr[i]._id.length > 0) {
          this.segmentationBarChartLabels.push(barLableArr[i]._id.split(" "));
          barData.push(barLableArr[i].count);
          this.totalSegmentationCount +=barLableArr[i].count;
        }
      }
      barCharArr.push({data: barData, backgroundColor: '#76b6bc', hoverBackgroundColor: '#76b6bc'});
      this.segmentationBarChartData = barCharArr;

      for (let i=0;i<res[1].data.length;i++) {
        this.segmentationPieChartLabels.push(res[1].data[i]._id);
        this.segmentationPieChartData.push(res[1].data[i].count);
      }
      // Bar chart for school
      barData = [];
      barCharArr = [];
      barLableArr = res[2].data.sort(this.compare);
      for (let i=0;i<barLableArr.length;i++) {
          this.segmentationBarSchoolChartLabels.push(barLableArr[i].name.replace('High School', ''));
          barData.push(barLableArr[i].count);
      }
      barCharArr.push({data: barData, backgroundColor: '#76b6bc', hoverBackgroundColor: '#76b6bc'});
      this.segmentationBarSchoolChartData = barCharArr;
      this.showSegmentationCharts = true;
    });
  }

  exportSectionData(instname : string, insttype:string) {
    this.reportService.generateCounsellorReport(instname, insttype).subscribe(res => {
      let fileName = res.headers.get('content-disposition').split(';')[1].split('=')[1].replace(/\"/g, '');
      FileSaver.saveAs(res.body, fileName);
    });
  }

  compare(a : any, b: any) {
	  // Use toUpperCase() to ignore character casing
	  const bandA = a.count ? parseInt(a.count) : 0;
	  const bandB = b.count ? parseInt(b.count) : 0;

	  let comparison = 0;
	  if (bandA < bandB) {
	    comparison = 1;
	  } else if (bandA > bandB) {
	    comparison = -1;
	  }
	  return comparison;
	}

  showAccordionView() {
    this.accordionView = !this.accordionView;
  }

  doughnutChartClicked(obj : any) {
    let label = this.groupIdx[obj.active[0]._index];
    Object.keys(this.group).forEach(key => {
      this.group[key] = label != key ? false : !this.group[label];
    });
  }

  openModalWithClass(template: TemplateRef<any>) {  
    this.modalRef = this.modalService.show(  
      template,  
      Object.assign({}, { class: 'gray modal-md popup-in' })  
    );  
  }  
  openModal(template: TemplateRef<any>) {  
    this.modalRef = this.modalService.show(  
      template,  
      Object.assign({}, { class: 'gray modal-lg popup-in' })  
    );  
  }  
sentReport(){
  const email=this.sentReportForm.get('inputEmail3').value;
  const subject=this.sentReportForm.get('subject').value;
  const comment=this.sentReportForm.get('exampleFormControlTextarea1').value;
  this.reportService.sendCounselorReport( email,subject, comment).subscribe(res => {

  });;
  this.close();
}
  close(){
    this.modalRef.hide();
  }

  
}


